import { AwsRum } from 'aws-rum-web'
import { logger } from './logger'

/**
 * awsRUMErrorCapture
 */
export default class AWSRUMErrorCaptureObject {
  captureException = (err: any | undefined) => {
    try {
      if (typeof awsRum === 'undefined' || awsRum === null) {
        return
      }
      if (typeof err === 'undefined' || err === null) {
        awsRum.recordError('undefined error')
      }
      awsRum.recordError(err)
    } catch (ex) {
      logger.warning('recordError exception...')
      logger.error(ex)
    }
  }
}

export const AWSRUMErrorCapture = new AWSRUMErrorCaptureObject()

// eslint-disable-next-line import/no-mutable-exports
let awsRum: AwsRum
export function initializeAwsRum(obj: AwsRum) {
  awsRum = obj
}
